import React from 'react';

const ChatMessage = ({ message }) => {
    const isBot = message.sender === 'bot';

    return (
        <div className={`flex w-full mb-4 ${isBot ? 'justify-start' : 'justify-end'}`}>
            <div className={`
                max-w-[80%] rounded-2xl px-5 py-3 shadow-sm text-sm leading-relaxed relative
                ${isBot
                    ? 'bg-white text-gray-700 rounded-tl-none border border-gray-100 shadow-sm'
                    : 'bg-gradient-to-r from-cherry-600 to-cherry-700 text-white rounded-tr-none shadow-cherry-200'
                }
            `}>
                {message.image && (
                    <div className="mb-2 rounded-lg overflow-hidden border border-white/20">
                        <img 
                          src={message.image} 
                          alt="Attachment" 
                          width="300"
                          height="200"
                          loading="lazy"
                          decoding="async"
                          className="max-w-full h-auto object-cover" 
                        />
                    </div>
                )}

                <div className="whitespace-pre-wrap">
                    {message.text}
                </div>

                <div className={`text-[10px] mt-1 opacity-70 ${isBot ? 'text-gray-400' : 'text-cherry-100 text-right'}`}>
                    {new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
            </div>
        </div>
    );
};

export default ChatMessage;
